import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import {
  authTokenSelector,
  authCurrentDefaultTypeSelecetor
} from '../../modules/auth/Selectors';

const AdminsRoute = props => {
  const { auth, userType, ...rest } = props;
  console.log(
    userType,
    'userType',
    userType !== '1',
    userType !== '0',
    userType !== '1' && userType !== '0'
  );
  if (!auth) return <Redirect to='/login' />;
  if (userType !== '1' && userType !== '0') {
    //  toast.error('Auth Error');
    console.log('rout', userType);
    return <Redirect to='/dashboard' />;
  }
  return <Route {...rest} />;
};

const mapStateToProps = state => {
  return {
    auth: authTokenSelector(state),
    userType: authCurrentDefaultTypeSelecetor(state)
  };
};

export default connect(mapStateToProps)(AdminsRoute);
